// Router module

import Vue from 'vue'

import Vuex from 'vuex'
const MD5 = require('crypto-js/md5')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    collectives: {},
    users: [],
    images: [],
    userCollectives: {},
    currentUser: null,
    currentUserContext: {
      handle: '',
      fullname: '',
      userProfileImg: '',
      r_user_id: ''
    }
  },
  getters: {
    user (state) {
      return state.currentUser ? Object.assign(state.currentUser, state.currentUserContext) : false
    },
    allCollectives (state) {
      return state.collectives
    }
  },
  mutations: {
    loginUser (state, payload) {
      state.currentUser = payload
    },
    logoutUser (state) {
      state.currentUser = null
    },
    updateUser (state, payload) {
      state.currentUser = Object.assign(state.currentUser, payload)
    },
    updateContext (state, payload) {
      state.currentUserContext = Object.assign(state.currentUserContext, payload)
    },
    addCollective (state, payload) {
      // `payload` must be the collective object, no exceptions!
      let collectiveWrapper = {}
      collectiveWrapper['@' + payload.handle] = payload
      state.collectives = Object.assign(state.collectives, collectiveWrapper)
    },
    addUserCollective (state, payload) {
      // `payload` must be the collective object, no exceptions!
      let collectiveWrapper = {}
      collectiveWrapper['@' + payload.handle] = payload
      state.collectives = Object.assign(state.collectives, collectiveWrapper)
      state.collectives = Object.assign(state.userCollectives, collectiveWrapper)
    }
  },
  actions: {
    fetchUser ({commit, dispatch}, payload) {
      // This applies throughout the entire app. No need to duplicate
      Vue.prototype.$firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          commit('loginUser', user)
          dispatch('updateUserContext')
        } else {
          commit('logoutUser')
        }
      })
    },
    updateUserContext ({state, commit}) {
      // Fetches information from the user database
      // or uses local storage information
      commit('updateContext', {
        userProfileImg: 'https://www.gravatar.com/avatar/' + MD5(String.toLowerCase(state.currentUser.email.trim())),
        r_user_id: state.currentUser.uid
      })

      Vue.prototype.$firestore.collection('users')
        .doc(state.currentUser.uid).get()
        .then((doc) => {
          if (doc.exists) {
            commit('updateContext', doc.data())
          } else {
            // Create a document for no errors
            // Account Creation:
            // Be sure to set the currentUserContext!
            Vue.prototype.$firestore.collection('users')
              .doc(state.currentUser.uid)
              .set(state.currentUserContext, { merge: true })
          }
        }).catch(() => {
          throw new Error('Could not get the current user!')
        })
    },
    fetchCollective ({state, commit}, payload) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$firestore.collection('collectives').doc('@' + payload)
          .get().then((doc) => {
            if (doc.exists) {
              commit('addCollective', doc.data())
              resolve(doc.data())
            } else {
              resolve(false)
            }
          }).catch(() => {
            throw new Error('Could not get the current collective!')
          })
      })
    },
    fetchUserCollectives ({state, commit}) {
      return new Promise((resolve, reject) => {
        if (state.currentUser) {
          Vue.prototype.$firestore.collection('collectives').where('members.' + state.currentUser.uid, '>=', 1)
            .get().then((docs) => {
              docs.forEach((collective) => {
                commit('addUserCollective', collective.data())
              })
              resolve(true)
            })
        } else {
          resolve(false)
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js